module.exports = __webpack_public_path__ + "img/stock7.d0841a98.png";